import { getAuthCode } from "./getAuthCode";

export const sendLinkedinInvite = async (voiceId, email) => {
  try {
    const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/sendLinkedinInvite", {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ auth_code: await getAuthCode(), voiceId, email })
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error sending LinkedIn invite:", error);
    throw error;
  }
};
